import React from 'react'
import PropTypes from 'prop-types'
import resolveProps from '../../../utils/resolveProps'
import { TopicDetailsProps } from './types'

const config = {
  types: [
    {
      title: 'default',
      isDefault: true
    },
    'inverse'
  ],
  modifiers: ["brand"],
  state: []
}
function TopicDetails(props: TopicDetailsProps ) {
  const { data } = props
  const hasBrand = Object.keys(props).find((t) => t === 'brand')

  return (
    <div className={resolveProps(props, config, 'TopicDetails')}>
      {!hasBrand ? (
        <>
          {data?.map((topic, index) => (
            <div key={`topic_${index}`} className="mdn-TopicDetails-group">
              <div className={`mdn-Topic mdn-Topic--horizontal mdn-Topic--${topic.icon.size}`}>
                <div className="mdn-Topic-symbol">
                  <i
                    className={`${topic.icon.name} mdn-Icon--${topic.icon.size}`}
                  ></i>
                </div>
                <p className="mdn-Topic-description">{topic.description}</p>
              </div>
              <p className="mdn-Text mdn-Text--body">{topic.body}</p>
            </div>
          ))}
        </>
      ) : (
        <>
          {data?.map((topic, index) => (
            <div key={`topic_${index}`} className="mdn-TopicDetails-group">
              <div className="mdn-Topic mdn-Topic--horizontal mdn-Topic--sm">
                <div className="mdn-Topic-symbol">
                  <img src={topic.brand.src} alt={topic.brand.alt} />
                </div>
                <p className="mdn-Topic-description">{topic.description}</p>
              </div>
              <p className="mdn-Text mdn-Text--body">{topic.body}</p>
            </div>
          ))}
        </>
      )}
    </div>
  )
}

TopicDetails.propTypes = {
  inverse: PropTypes.bool,
  data: PropTypes.array
}

export default TopicDetails
